import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { EVENT_LIST } from '@constants/routes';
import { useEventCreationRevoked } from '@hooks/use-event-creation-revoked/use-event-creation-revoked';
import { VIEW_UPCOMING } from '@hooks/use-event-navigation/use-event-navigation';
import { useToast } from '@hooks/use-toast/use-toast';

export const useRedirectRevokedEventCreation = (isCreating = true) => {
  const navigate = useNavigate();
  const toast = useToast();
  const { companyId = '', clubSlug = '' } = useParams<{ companyId: string; clubSlug: string }>();
  const { isEventCreationRevoked, isEventCreationPending, revokedReason } = useEventCreationRevoked();
  const shouldRedirect = isCreating && isEventCreationRevoked;

  useEffect(() => {
    if (!shouldRedirect) return;
    toast.push({ title: revokedReason, text: '', type: 'error' });
    navigate(
      EVENT_LIST.replace(':companyId', companyId).replace(':clubSlug', clubSlug).replace(':view', VIEW_UPCOMING),
      { replace: true }
    );
  }, [shouldRedirect, revokedReason, companyId, clubSlug, navigate, toast]);

  return isCreating && (shouldRedirect || isEventCreationPending);
};
